function MeccaLoading() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-8">
      {/* Simple Loading Animation with ChatGPT logo */}
      <div className="relative mb-12">
        {/* Spinning border around your logo */}
        <div className="relative w-32 h-32 mx-auto">
          {/* Spinning outer ring */}
          <div className="absolute inset-0 border-4 border-yellow-200 border-t-yellow-600 rounded-full animate-spin-slow"></div>
          <div className="absolute inset-4 border-2 border-yellow-300/30 border-t-yellow-500 rounded-full animate-spin-slow" style={{animationDirection: 'reverse', animationDuration: '3s'}}></div>
          
          {/* Center - Your ChatGPT logo */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
            <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-yellow-500 shadow-xl">
              <img 
                src="/ChatGPT.png" // Your ChatGPT logo
                alt="Mecca Prayer House"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          
          {/* Orbiting prayer dots */}
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 animate-spin-slow">
            <div className="w-4 h-4 bg-yellow-500 rounded-full shadow-md"></div>
          </div>
          <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 animate-spin-slow">
            <div className="w-4 h-4 bg-yellow-500 rounded-full shadow-md"></div>
          </div>
          <div className="absolute left-0 top-1/2 transform -translate-x-1/2 -translate-y-1/2 animate-spin-slow">
            <div className="w-4 h-4 bg-yellow-500 rounded-full shadow-md"></div>
          </div>
          <div className="absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2 animate-spin-slow">
            <div className="w-4 h-4 bg-yellow-500 rounded-full shadow-md"></div>
          </div>
          
          {/* Corner prayer dots */}
          <div className="absolute top-1/4 left-1/4 transform -translate-x-1/2 -translate-y-1/2 animate-spin-slow" style={{animationDuration: '4s'}}>
            <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
          </div>
          <div className="absolute top-1/4 right-1/4 transform translate-x-1/2 -translate-y-1/2 animate-spin-slow" style={{animationDuration: '4s'}}>
            <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
          </div>
          <div className="absolute bottom-1/4 left-1/4 transform -translate-x-1/2 translate-y-1/2 animate-spin-slow" style={{animationDuration: '4s'}}>
            <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
          </div>
          <div className="absolute bottom-1/4 right-1/4 transform translate-x-1/2 translate-y-1/2 animate-spin-slow" style={{animationDuration: '4s'}}>
            <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
          </div>
        </div>
      </div>
      
      {/* Loading Text */}
      <div className="text-center mb-8 animate-fadeIn">
        <p className="text-2xl text-yellow-700 font-bold mb-2">
          Mecca Prayer House
        </p>
        <p className="text-lg text-yellow-700 font-medium mb-2">
          Loading Prayer Times
        </p>
        <p className="text-sm text-yellow-500">
          Preparing accurate schedules for your location...
        </p>
      </div>
      
      {/* Simple Progress Indicator */}
      <div className="w-64 mb-8 animate-fadeIn">
        {/* Progress bar */}
        <div className="w-full h-2 bg-yellow-100 rounded-full overflow-hidden mb-2">
          <div className="h-full bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full animate-progress"></div>
        </div>
        
        {/* Progress dots */}
        <div className="flex justify-between px-2">
          {[1, 2, 3, 4, 5].map((step) => (
            <div key={step} className="flex flex-col items-center">
              <div 
                className={`w-2 h-2 rounded-full ${step <= 3 ? 'bg-yellow-500' : 'bg-yellow-200'} animate-pulse`}
                style={{animationDelay: `${step * 0.2}s`}}
              ></div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Simple Faith Symbols */}
      <div className="flex space-x-6 mb-6 animate-fadeIn">
        <span className="text-xl text-yellow-500 animate-pulse-slow">🕌</span>
        <span className="text-xl text-yellow-500 animate-pulse-slow" style={{animationDelay: '0.1s'}}>✝️</span>
        <span className="text-xl text-yellow-500 animate-pulse-slow" style={{animationDelay: '0.2s'}}>🙏</span>
        <span className="text-xl text-yellow-500 animate-pulse-slow" style={{animationDelay: '0.3s'}}>🕯️</span>
        <span className="text-xl text-yellow-500 animate-pulse-slow" style={{animationDelay: '0.4s'}}>☪️</span>
      </div>
      
      {/* Prayer Verse */}
      <div className="text-center animate-fadeIn max-w-md">
        <div className="bg-yellow-50 rounded-lg p-4 border border-yellow-100">
          <p className="text-sm text-yellow-700 font-medium">
            "And establish prayer and give zakah and bow with those who bow."
          </p>
          <p className="text-xs text-yellow-500 mt-1">
            Quran 2:43
          </p>
        </div>
      </div>
    </div>
  );
}

export default MeccaLoading;